import '../App.css';

import { Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, NavLink, FormControl, Form, Alert } from 'react-bootstrap';

import $ from "jquery";
import Faq from "./Faq";
import React, { useState, Component } from 'react';
import axios from "axios";
import { Sida, Rubrik, Stycke, ContentWrapper, Rubrik_ } from "./ContentStyles";
import Prices from "./Prices";
import CountDown from "./CountDown";
import ReactPlayer from 'react-player';
import Album from "./Album";
import Rules from './Rules';
import "./Home.scss";
import {
  FaMobileAlt,
  FaStore,
  FaBarcode,
  FaCreditCard,
  FaLock,
} from "react-icons/fa";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";




const shoot = () => {
  alert();
}

const Home = () => {

  return (
    <ContentWrapper>
      <Container>
        <Sida>
          <section className="hero">
            <div className="hero__bg" />

            <div className="hero__grid">
              <div className="hero__left">
                {/* <div className="hero__badge"><BsLightning /> Snabbt. Enkelt. Säkert.</div> */}

                <h1 className="hero__title">
                  Skapa din egen <br />
                  <span>24/7 butik</span>
                </h1>

                <p className="hero__lead">
                  Låt dina kunder handla när som helst på dygnet med vår smarta app. Lås upp, skanna och
                  betala.
                </p>

                <div className="hero__actions">
                  {/* <a className="hero__btn hero__btn--primary" href="https://apps.apple.com/se/app/nookshop/id6443705977">
                    Hämta appen
                  </a> */}
                  <a className="hero__btn hero__btn--primary" href="/pris">
                    Abonnemang
                  </a>
                  <button
                    type="button"
                    className="hero__btn hero__btn--secondary"
                    onClick={() => {
                      document.getElementById("how")?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    Upptäck
                  </button>
                </div>

                <div className="hero__stats">
                  <div className="hero__stat">
                    <div className="hero__statValue">24/7</div>
                    <div className="hero__statLabel">Tillgängligt</div>
                  </div>
                  <div className="hero__stat">
                    <div className="hero__statValue">BankID</div>
                    <div className="hero__statLabel">Verifiering</div>
                  </div>
                  <div className="hero__stat">
                    <div className="hero__statValue">Swish</div>
                    <div className="hero__statLabel">Betalning</div>
                  </div>
                </div>
              </div>

              <div className="hero__right ">
                <div className="hero__card hero__card--tiltA hero-card rotate-right">
                  <div className="hero__cardHeader">
                    <div className="hero__icon"><FaMobileAlt /></div>
                    <div>
                      <div className="hero__cardTitle">Så fungerar det för dig</div>
                    </div>
                  </div>

                  <div className="hero__rows">
                    <div className="hero__row hero__row--ok">Vi installerar systemet åt dig</div>
                    <div className="hero__row hero__row--info">Kunder legitimerar sig och handlar via appen</div>
                    <div className="hero__row hero__row--warm">Du får full kontroll och automatiserad försäljning</div>
                  </div>
                </div>

                <div className="hero__card hero__card--tiltB hero__card--orange hero-card rotate-left">
                  <div className="hero__small">Inspiration</div>
                  <div className="hero__offer">Såhär kan din butik se ut</div>
                  <a className="hero__pill" href="/galleri">Se galleri</a>
                </div>

                <div className="hero__glow" />
              </div>
            </div>
          </section>

          <section className="infoCard">
            <div className="infoCard__inner">
              <div className="infoCard__head">
                <div className="infoCard__badge">Om nookshop</div>

              </div>

              <div className="infoCard__grid">
                <div className="infoCard__col">
                  <p className="infoCard__body">
                    Hörnbutik som det skulle kunna heta på svenska om det inte låtit coolare på engelska är ett system för obemannade butiker.
                    Kunden låser upp butiken genom att legitimera sig med BankID och betalar sina varor med Swish, så enkelt är det.
                    Vår ambition är att det ska vara nästan lika enkelt att öppna en butik.
                  </p>
                </div>

                <div className="infoCard__col">
                  <div className="infoCard__sub">Exempel på verksamheter</div>
                  <ul className="infoCard__list">
                    <li>Gårdsbutiker</li>
                    <li>Kioskverksamhet</li>
                    <li>Hotell/Vandrarhem</li>
                    <li>Livsmedelsbutik</li>
                    <li>Golfbanor</li>
                    <li>Arbetsplatser</li>
                    <li>Idrottshallar</li>
                    <li>Föreningar</li>
                    <li>Gym</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>




          <div Style="">


            <div>
              <div>
                <section id='how' className="how">
                  <div className="how__head">
                    <span className="how__badge">Så här fungerar det</span>
                    <h2 className="how__title">Redo på 6 enkla steg</h2>
                    <p className="how__subtitle">
                      Från app till färdigköpt på några minuter
                    </p>
                  </div>

                  <div className="how__wrap">


                    <div className="how__grid">


                      {/* Step 1 */}
                      <div className="how__card how__card--highlight">
                        <div className="how__num">1</div>

                        <div className="how__icon">
                          <FaMobileAlt />
                        </div>

                        <h3 className="how__cardTitle">Ladda ner appen</h3>

                        <p className="how__cardText">
                          Hämta vår app från App Store eller Google Play
                        </p>

                        <div className="how__stores">
                          <a href="https://apps.apple.com/se/app/nookshop/id6443705977">
                            <img
                              src="https://www.nookshop.se/images/AppStore.png"
                              alt="App Store"
                            />
                          </a>

                          <a href="https://play.google.com/store/apps/details?id=cloudsolution.nookshop">
                            <img
                              src="https://www.nookshop.se/images/GooglePlay.png"
                              alt="Google Play"
                            />
                          </a>
                        </div>
                      </div>


                      {/* Step 2 */}
                      <div className="how__card">
                        <div className="how__num">2</div>
                        <div className="how__icon">
                          <FaStore />
                        </div>
                        <h3 className="how__cardTitle">Lås upp butiken</h3>
                        <p className="how__cardText">
                          Ange butiksid och legitimera dig med BankID
                        </p>
                      </div>

                      {/* Step 3 */}
                      <div className="how__card">
                        <div className="how__num">3</div>
                        <div className="how__icon">
                          <FaBarcode />
                        </div>
                        <h3 className="how__cardTitle">Skanna varorna</h3>
                        <p className="how__cardText">
                          Använd appen för att skanna streckkoden
                        </p>
                      </div>

                      {/* Step 4 */}
                      <div className="how__card">
                        <div className="how__num">4</div>
                        <div className="how__icon">
                          <FaCreditCard />
                        </div>
                        <h3 className="how__cardTitle">Betala enkelt</h3>
                        <p className="how__cardText">
                          Betala snabbt och säkert med Swish
                        </p>
                      </div>

                      {/* Step 5 */}
                      <div className="how__card">
                        <div className="how__num">5</div>
                        <div className="how__icon">
                          <FaLock />
                        </div>
                        <h3 className="how__cardTitle">Stäng dörren</h3>
                        <p className="how__cardText">
                          Dörren låser sig automatiskt
                        </p>
                      </div>

                      {/* Step 6 */}
                      <div className="how__card how__card--final">
                        <div className="how__num">6</div>
                        <div className="how__icon how__icon--white">
                          <IoMdCheckmarkCircleOutline />
                        </div>
                        <h3 className="how__cardTitle">Du är klar!</h3>
                        <p className="how__cardText">
                          Kvittot skickas till din mejl
                        </p>
                      </div>

                    </div>
                  </div>
                </section>

              </div>
            </div>



            {/* <div className='' Style="float: right;height: auto; max-width:420px;">
              <ReactPlayer url='handlaiennook.mp4' controls={true} playing={true} muted={true} loop={true} width='100%' height='100%' />
            </div> */}




            <div Style="clear:both;"></div>
            <div className="demoSide">
              <div className="demoSide__frame">
                <div className="demoSide__decor demoSide__decor--a" aria-hidden="true" />
                <div className="demoSide__decor demoSide__decor--b" aria-hidden="true" />

                <div className="demoSide__video">
                  <ReactPlayer
                    url="handlaiennook.mp4"
                    controls={true}
                    playing={true}
                    muted={true}
                    loop={true}
                    width="100%"
                    height="100%"
                  />
                </div>

                <div className="demoSide__content">
                  <div className="demoSide__badge">
                    <span className="demoSide__badgeIcon">▶</span>
                    <span>Se hur det fungerar</span>
                  </div>

                  <h2 className="demoSide__title">
                    Upplev <span>nookshop</span> in action
                  </h2>

                  <p className="demoSide__text">
                    Så här enkelt är det att handla i en obemmanad butik
                  </p>
                </div>
              </div>
            </div>
          </div>



          {/* <Rubrik>Bilder</Rubrik>
          <Album /> */}
          {/* <Faq /> */}

        </Sida>
      </Container>

    </ContentWrapper>
  );
}

export default Home;